module.exports = __webpack_public_path__ + "static/media/2.02faa022.mp4";